// extracted by mini-css-extract-plugin
export default {"contact":"Contact_contact__dUenW","input":"Contact_input__Jq7Cx","inputs":"Contact_inputs__WdIj0","warning":"Contact_warning__GZoit"};